export type CameraPickerButtonProps = {
  isLoading: boolean;
  onPermissionCheckStart: () => void;
  onPermissionCheckComplete?: () => void;
  onPermissionDenied?: () => void;
  setIsLoading: (loading: boolean) => void;
  openCamera: () => void;
};
export const CameraPickerButton = (_: CameraPickerButtonProps) => {
  console.error("Not implemented for web");
  return null;
};